// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');

// @constants
const { MYPROFILE_BROKER_EXPLORE_URL } = require('constants/index');

const StartToInvestButton = props => {
    const { label, onClick } = props;

    return (
        <div className="my-wallet-actual-tab__start-to-invest-container">
            <OKButton
                modifier="secondary"
                to={MYPROFILE_BROKER_EXPLORE_URL}
                onClick={onClick}
            >
                {label}
            </OKButton>
        </div>
    )
}

StartToInvestButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

module.exports = StartToInvestButton;
